import { render, staticRenderFns } from "./FootFallDetails.vue?vue&type=template&id=24a56db4&"
import script from "./FootFallDetails.vue?vue&type=script&lang=js&"
export * from "./FootFallDetails.vue?vue&type=script&lang=js&"
import style0 from "./FootFallDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports